import React from "react";
import { Copy, Check } from "lucide-react";

/**
 * Single read-only field with a copy-to-clipboard button.
 * Used by /pagar manual-payment beneficiary display.
 */
export default function CopyRow({ label, value, copied, onCopy, testId }) {
  return (
    <div className="flex items-center justify-between gap-3 py-1.5 border-b last:border-b-0 border-zinc-100">
      <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-widest font-bold text-zinc-500">{label}</p>
        <p className="text-sm font-mono font-bold text-zinc-900 truncate">{value}</p>
      </div>
      <button
        onClick={onCopy}
        data-testid={testId}
        className="flex-shrink-0 w-9 h-9 rounded-lg bg-zinc-100 hover:bg-zinc-200 flex items-center justify-center"
      >
        {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4 text-zinc-700" />}
      </button>
    </div>
  );
}
